import { defineStore } from 'pinia'
import { ref } from 'vue'
import { RouteLocationNormalized } from 'vue-router'

export const usePendingRouteStore = defineStore('pendingRoute', () => {
  // State
  const pendingRoute = ref<RouteLocationNormalized | null>(null)

  // Actions
  function setPendingRoute(payload: RouteLocationNormalized) {
    pendingRoute.value = payload
  }

  function resetPendingRoute() {
    pendingRoute.value = null
  }

  return {
    pendingRoute,
    setPendingRoute,
    resetPendingRoute
  }
})